// client/helper/doesMarkMatchAttributes.ts
function doesMarkMatchAttributes(mark, attrs) {
  return Object.keys(attrs).every((key) => mark.attrs[key] === attrs[key]);
}
export {
  doesMarkMatchAttributes
};
